export default __webpack_public_path__ + "static/media/father.980b0b2e.png";